module.exports = __webpack_public_path__ + "img/nodeBackgroundDrawObliqueWhite.1fa638a8.svg";